import { useProgressStore } from "../stores";

export const createFormData = (obj: Record<string, any>): FormData => {
  const fd = new FormData();

  for (let key in obj) {
    if (!obj[key]) continue;
    addToFD([fd], key, obj[key]);
  }

  return fd;
};

const addToFD = (
  fd: FormData[],
  key: string,
  value: any,
  child: boolean = false
): void => {
  if (key.endsWith("[]") && !child) {
    Array.from(value).forEach((v) => {
      addToFD([fd[0]], key, v, true);
    });
  } else if (value.name && value.lastModified && value.size) {
    fd[0].append(key, value as File);
  } else if (typeof value === "object") {
    fd[0].append(key, JSON.stringify(value));
  } else {
    fd[0].append(key, value);
  }
};

export const parseApiData = (obj: Record<string, any>): Record<string, any> => {
  let res: Record<string, any> = {};

  for (let key in obj) {
    if (!obj[key]) continue;
    res[key] = obj[key];
  }

  return res;
};

export const getFileHeaders = (
  files: FileList | File | null
): Record<string, string> => {
  const headers: Record<string, string> = {
    "x-files-id": "",
    "x-files-len": "",
  };

  if (!files) return headers;

  if ((files as FileList).length) {
    files = files as FileList;

    let xFilesLen = "";
    Array.from(files).forEach((file) => {
      xFilesLen += `${file.size},`;
    });
    xFilesLen = xFilesLen.substring(0, xFilesLen.length - 1);
    headers["x-files-len"] = xFilesLen;

    let xFilesId = "";
    Array.from(files).forEach((file) => {
      let id = useProgressStore.getState().progressMapAdd(file.name);
      xFilesId += `${id},`;
    });
    xFilesId = xFilesId.substring(0, xFilesId.length - 1);
    headers["x-files-id"] = xFilesId;
  } else {
    files = files as File;

    headers["x-files-len"] = `${files.size}`;

    let id = useProgressStore.getState().progressMapAdd(files.name);
    headers["x-files-id"] = `${id}`;
  }

  return headers;
};
